<template>
<div class="contentGlobal">
    <div class="pTop">
       
        <b-col rows="12" height="100%">
          <h2>Connected pools progression</h2>
                <div ref="chartdiv" class="cont" style="height:400px">  </div>
        </b-col>
        <b-container class="bv-example-row">
            <b-row>
                <b-col class="bg">
                    <p>Total pools</p>
                    <h2>{{ objData.totalPools }}</h2>
                </b-col>
                <b-col class="bg">
                    <p>Total users</p>
                    <h2>{{ objData.totalUsers }}</h2>
                </b-col>
                <b-col class="bg">
                    <p>Managed pools this year</p>
                    <h2>{{ objData.managedPools }}</h2>
                </b-col>
              
            </b-row>
        </b-container>
    </div>
</div>

</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4themes_dark from "@amcharts/amcharts4/themes/dark";
import { mapState} from 'vuex'


am4core.useTheme(am4themes_animated);
import {
    LMap,
    LTileLayer,
    LPopup,
    LMarker
} from "vue2-leaflet";

export default {
    name: 'admin',
    components: {
        LMap,
        LTileLayer,
        LPopup,
        LMarker
    },
    data: function () {
        return {
            url: "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
            zoom: 12,
            map: null,
            mapLayer: null,
            markers: [],
            bounds: {},
            isLoading: true,
            objData:{},
            infoContent:{
                name:'',
                lat:'',
                lng:''
            },
        };
    },
    created() {
        this.$nextTick(() => {
            setTimeout(() => {
               // this.getAdminLocations()
               this.getAdminLocations();
              // this.fillData();
            },2000);
        })
    },
 
    computed: {
        ...mapState(['userProfile'])
    },
    methods: {
        fillData(){
            var values = this.objData.progress;
            // let chart = this.chart
            let chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart);
            let data = [];
            for (let i = 0; i < values.length; i++) {
                data.push({ date: values[i].dt, value: values[i].count});
            }

            chart.data = data;
            // Create axes
            let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.min = 0;
            // Create series
            let series = chart.series.push(new am4charts.LineSeries());
            series.dataFields.valueY = "value";
            series.dataFields.dateX = "date";
            series.strokeWidth = 2;
            series.minBulletDistance = 5;
            series.fillOpacity = 0.3;
            series.color = "#ff0000";
            
        // series.tooltip = "{value}");
            series.adapter.add('tooltipText', (text, target) => {
            let data = target.tooltipDataItem.dataContext;
                if (target.tooltipDataItem.dataContext) {
                let val = data.value;
                return val;
                }
                else {
                return text;
                }
            });
                    
            // Make bullets grow on hover
            let bullet = series.bullets.push(new am4charts.CircleBullet());
            bullet.circle.strokeWidth = 0;
            bullet.circle.radius = 0;
            bullet.circle.fill = am4core.color("#fff");

            let bullethover = bullet.states.create("hover");
            bullethover.properties.scale = 1.3;

            // Make a panning cursor
            chart.cursor = new am4charts.XYCursor();
            //chart.cursor.behavior = "panXY";
            chart.cursor.xAxis = dateAxis;
            chart.cursor.snapToSeries = series;
    

            // Create vertical scrollbar and place it before the value axis
            chart.scrollbarY = new am4core.Scrollbar();
            chart.scrollbarY.parent = chart.leftAxesContainer;
            chart.scrollbarY.toBack();

            // Create a horizontal scrollbar with previe and place it underneath the date axis
            chart.scrollbarX = new am4charts.XYChartScrollbar();
            chart.scrollbarX.series.push(series);
            chart.scrollbarX.parent = chart.bottomAxesContainer;

            chart.exporting.menu = new am4core.ExportMenu();
            chart.exporting.filePrefix = "pool-totals";
            chart.exporting.dateFields.push("date");
            chart.exporting.dateFormat = "YYYY-MM-dd";     
            this.isLoading = false
      },
        getAdminLocations() {
            this.loading = true;
            this.$snotify.async( 'Loading', () => new Promise((resolve, reject) => {
                this.$store.dispatch('getAdminStats').then(response => {
                    if(response) {
                    this.objData = response.data;
                    this.fillData();
                      resolve({   
                          config: {
                            timeout: 3000,
                            closeOnClick: true
                        }
                        })
                    } 
                }, error => {
                    // error retrieving data
                    console.log(error)
                     reject({
                         body: this.$t("messages.retrieveDataError"),
                         config: {
                            timeout: 3000,
                            closeOnClick: true
                        }
                     })
                })
            }, error => {
                console.log(error)
            }))
        }
    }
}
</script>
<style scoped>
.inner p {
    color:black;
}

.leaflet-popup-content p {
    margin: 2px 0; 
}
.pTop{
    padding-top: 80px;  
}

.bg{
    background-color:lightgray;
    padding: 12px;
}
.bg p{
font-size: 1.75rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin.vue